import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Tooltip, TablePagination, TextField } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { Feast } from '../../types';

interface Props { items: Feast[]; loading: boolean; total: number; page: number; limit: number; onPageChange: (p: number) => void; onEdit: (i: Feast) => void; onDelete: (id: number) => void; }

export function FeastsTable({ items, loading, total, page, limit, onPageChange, onEdit, onDelete }: Props) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead><TableRow>
          <TableCell>Название</TableCell><TableCell>Дата</TableCell><TableCell>Храм</TableCell><TableCell>Действия</TableCell>
        </TableRow></TableHead>
        <TableBody>
          {items.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.date || '-'}</TableCell>
              <TableCell>{item.temple?.name || '-'}</TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Tooltip title="Редактировать"><IconButton size="small" onClick={() => onEdit(item)}><Edit fontSize="small" /></IconButton></Tooltip>
                  <Tooltip title="Удалить"><IconButton size="small" onClick={() => onDelete(item.id)} sx={{ color: 'error.main' }}><Delete fontSize="small" /></IconButton></Tooltip>
                </Box>
              </TableCell>
            </TableRow>
          ))}
          {items.length === 0 && !loading && (<TableRow><TableCell colSpan={4} align="center"><Typography color="text.secondary">Данные не найдены</Typography></TableCell></TableRow>)}
        </TableBody>
      </Table>
      <TablePagination component="div" count={total} page={page - 1} onPageChange={(_, p) => onPageChange(p + 1)} rowsPerPage={limit} onRowsPerPageChange={() => {}} rowsPerPageOptions={[]} />
    </TableContainer>
  );
}
export function FeastsToolbar({ search, onSearchChange }: { search: string; onSearchChange: (v: string) => void }) {
  return (<Box sx={{ display: 'flex', gap: 2, mb: 2 }}><TextField label="Поиск" size="small" value={search} onChange={(e) => onSearchChange(e.target.value)} sx={{ minWidth: 260 }} /></Box>);
}
